export function sanitizeDownloadNamePart(value: string | null | undefined, fallback: string): string {
    const cleaned = (value ?? '').replace(/[^a-zA-Z0-9]+/g, '')
    return cleaned === '' ? fallback : cleaned
}

export function accRatesCsvFileName(shortName: string | null | undefined, years: readonly number[]): string {
    const utility = sanitizeDownloadNamePart(shortName, 'utility')
    const uniqueYears = [...new Set(years)].sort((a, b) => a - b)
    const yearPart = uniqueYears.length > 0 ? `-${uniqueYears.join('-')}` : ''
    return `acc-rates-${utility}${yearPart}.csv`
}

export function tariffAuditPackageFileName(
    shortName: string | null | undefined,
    schedule: string | null | undefined,
    ratesetDate: string | Date | null | undefined
): string {
    const utility = sanitizeDownloadNamePart(shortName, 'utility')
    const schedulePart = sanitizeDownloadNamePart(schedule, 'tariff')
    let datePart = 'rateset'
    if (ratesetDate instanceof Date && !Number.isNaN(ratesetDate.getTime())) {
        datePart = ratesetDate.toISOString().slice(0, 10)
    } else if (typeof ratesetDate === 'string' && ratesetDate !== '') {
        datePart = ratesetDate.slice(0, 10)
    }
    return `tariff-${utility}-${schedulePart}-${datePart}.zip`
}
